import "../../style/scss/App.scss";

export default function PackageListItem(props) {
  const pkg = props.package || props.packages || {};
  const id = pkg.ID || pkg.id;

  return (
    <button
      type="button"
      className="centered skillLink package-list-item"
      data-testid={id ? `package-edit-${id}` : "package-edit"}
      onClick={() => props.onEdit?.(id)}
    >
      <div className="Role mobilePanel">
        <span className="title">{pkg.Name || pkg.name}</span>
        <span className="byline"></span>
        <span className="rightText"></span>
      </div>
    </button>
  );
}
